import React, {useEffect, useState} from "react";
import associateServices from "../../services";
import {Link} from "react-router-dom";
import SvgIcon from "../svg-icon";
import {useTranslation} from "react-i18next";
import StyleHelper from "../../helpers/styleHelper";
import stringHelper from "../../helpers/string-helper";
import {Splide, SplideSlide} from '@splidejs/react-splide';
import {Navigation} from "swiper/modules";
import {miniGamePoints, points} from "../../helpers/splide-helper";
import {Swiper, SwiperSlide} from "swiper/react";
import {useSelector} from "react-redux";
import store from "../../reducers/createReducers";
import DataActions from "../../actions/data-actions";
import {LazyLoadImage} from "react-lazy-load-image-component";

const MiniGames = () => {
    const {miniGames} = useSelector(state => state.dataReducer)

    const {t, i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [coloredData, setColoredData] = useState([])
    useEffect(() => {
        setColoredData(data?.map(oo => ({
            ...oo,
            color: oo.color === 'random' ? StyleHelper.getRandomColor() : oo.color
        })))
        setLoading(false)
    }, [data])


    useEffect(() => {
        if (!loading && data?.length <= 0) {
            setLoading(true)
            associateServices.getDashboardSlideGames({
                type: 'mini'
            }).then(res => {
                store.dispatch(DataActions.setMiniGames(res?.data || []))
                // setData(res?.data)
            })
        }

    }, [data])


    useEffect(() => {
        setData(miniGames)
    }, [miniGames])
    if (!loading && data.length <= 0)
        return null

    return (
        <div className="section" id={"mini-games-wrapper"}>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        {
                            coloredData?.length >= 1 &&

                            <h2 className="section__title">
                                <SvgIcon id={'mini-games'}/>
                                {t('groups.mini-games')}
                            </h2>
                        }
                    </div>

                    <div className="col-12">

                        <Swiper
                            spaceBetween={12} // Space between slides
                            slidesPerView={1}
                            breakpoints={miniGamePoints}
                            className="mySwiper"
                            loop={coloredData?.length >= 5}
                        >
                            {
                                coloredData?.map((game, i) => (
                                    <SwiperSlide key={i}>
                                        <Link
                                            to={stringHelper.getLocalizedPath(currentLanguage, `/casino/games/${game.slug}`)}
                                            className={`mini-game mini-game--carousel mini-game--${game?.color === 'no' ? 'no-layer' : ''}`}>

                                                  <span className="mini-game__img">
                                                    <LazyLoadImage
                                                        height={'100%'}
                                                        width={'100%'}
                                                        effect="blur"
                                                        placeholderSrc={game.image}
                                                        src={game.image}
                                                        alt={game.title}/>
                                                    </span>


                                            <span className="mini-game__title">
                                                    <h3>{game?.name}</h3>
                                                    </span>
                                        </Link>
                                    </SwiperSlide>
                                ))
                            }
                        </Swiper>

                    </div>
                </div>
            </div>
        </div>
    )

}

export default React.memo(MiniGames)
